import { render } from "./BloodBank.vue?vue&type=template&id=ae4dbee4&scoped=true"
import script from "./BloodBank.vue?vue&type=script&lang=js"
export * from "./BloodBank.vue?vue&type=script&lang=js"

import "./BloodBank.vue?vue&type=style&index=0&id=ae4dbee4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4dbee4"]])

export default __exports__